<template>
    <div class="main">
        
        <FiltroDatosMultiVariable titulo="Gráfico" esGraficas="1" ref="filtergraph" v-show="!showChart" v-on:selectedValues="onSelectedValues">
            <template v-slot:header>
                <v-icon class="mr-3">mdi-chart-areaspline</v-icon>
                <v-toolbar-title>Gráficas</v-toolbar-title>
                <v-spacer></v-spacer>
            </template>
        </FiltroDatosMultiVariable>

        <template v-if="showChart">
            <!--<v-container fluid class="py-0">
        <v-row justify="start">
            <v-btn class="ma-2 mt-5 mb-6" small color="accent" dark @click="createPDF">
                PDF
                <v-icon dark right>mdi-adobe-acrobat</v-icon>
            </v-btn>
        </v-row>
    </v-container>-->
            <v-card class="mx-auto text-center ml-2">
                <v-toolbar color="green" dark>
                    <v-container fluid>
                        <v-card-actions>
                            <v-flex class="text-left" xs1>
                                <v-btn icon @click="onBack">
                                    <v-icon>mdi-arrow-left</v-icon>
                                </v-btn>
                            </v-flex>
                            <v-flex class="text-left" xs6>
                                {{nombreInstalacion}} {{nombreElemento}} - {{fromDate}} al {{toDate}}
                            </v-flex>
                            <v-flex class="text-right">
                                Periodos: <v-btn @click="getPrevNextPeriod('P')" style="font-size: 0.6em;background-color: #63be36">
                                    <v-icon>mdi-chevron-double-left</v-icon>Anterior
                                </v-btn>&nbsp;
                                <v-btn @click="getPrevNextPeriod('N')" style="font-size: 0.6em;background-color: #63be36">
                                    Siguiente<v-icon>mdi-chevron-double-right</v-icon>
                                </v-btn>

                            </v-flex>

                        </v-card-actions>
                    </v-container>

                    <v-spacer></v-spacer>
                </v-toolbar>

                <v-card-text>
                    <VueApexCharts ref="realtimeChart" type="line" :options="chartOptionsApexCharts" :series="series" :height="500"></VueApexCharts>
                </v-card-text>
                <v-card-actions>                   
                    <v-row>
                        <v-col cols="12" sm="2" class="pb-0">
                            <v-autocomplete width="20px" class="" v-model="sizeLine" :items="sizesLines" item-text="description" item-value="id" label="Tamaño Linea" outlined dense @change="redrawChart(sizeLine)"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="2" class="pb-0">
                            <v-autocomplete width="20px" class="" v-model="sizeMarker" :items="sizesMarkers" item-text="description" item-value="id" label="Tamaño Marcador" outlined dense @change="redrawChartMarker(sizeMarker)"></v-autocomplete>
                        </v-col>
                       
                    </v-row>
                </v-card-actions>


            </v-card>
        </template>
    </div>
</template>

<script>
    import {
        Component,
        Prop,
        Vue
    } from "vue-property-decorator";
    import FiltroDatosMultiVariable from '@/components/FiltroDatosMultiVariable'

    import {
        GChart
    } from 'vue-google-charts'
    import ChartService from '../services/ChartService';
    import jsPDF from 'jspdf';
    import html2canvas from 'html2canvas';
    import 'rasterizehtml';
    import InstalationsService from "../services/InstalationsService";
    import VariableService from "../services/VariableService";
    import ElementService from "../services/ElementService";
    import moment from 'moment';
    import VueApexCharts from 'vue-apexcharts';

    @Component({
        components: {
            GChart,
            FiltroDatosMultiVariable,
            VueApexCharts
        }
    })
    export default class Graficas extends Vue {
        mounted() {
            this.loadData();           
            if (this.$route.params.idI &&
                this.$route.params.idE &&
                this.$route.params.idV &&
                this.$route.params.f &&
                this.$route.params.t) {
                               
                this.onSelectedValues([{
                    idNInstalacion: this.$route.params.idI,
                    idNElements: this.$route.params.idE,
                    idNVariable: this.$route.params.idV,
                    from: moment.utc(this.$route.params.f).local(),
                    to: moment.utc(this.$route.params.t).local()
                }]);                  
            }
        }

        showChart = false;
        instalations = [];

        // Para mostrar 
        fromDate = "";
        toDate = "";
        nombreInstalacion = "";
        nombreElemento = "";
        nombreVariable = "";

        chartData = [];
        sizesLines = [
            { id: 1, description: "1" },
            { id: 2, description: "2" },
            { id: 3, description: "3" },
            { id: 4, description: "4" },
            { id: 5, description: "5" },
        ];
        sizesMarkers = [
            { id: 0, description: "0" },
            { id: 1, description: "1" },
            { id: 2, description: "2" },
            { id: 3, description: "3" },
            { id: 4, description: "4" },
            { id: 5, description: "5" },
        ];
        sizeLine = 2;
        sizeMarker = 1;
        chartOptionsApexCharts = {
            chart: {                
                type: 'line',
                dropShadow: {
                    enabled: true,
                    color: '#000',
                    top: 18,
                    left: 7,
                    blur: 10,
                    opacity: 0.2
                },
                zoom: {
                    type: 'x',
                    enabled: true,
                    autoScaleYaxis: true
                },
                toolbar: {
                    show: true,
                    offsetY: -10,
                }
            },
            tooltip: {
                custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                    var data = w.globals.initialSeries[seriesIndex].data[dataPointIndex];
                    return moment(new Date(data[0])).format("DD/MM/YYYY HH:mm:ss") + ' | ' + data[1];
                }
            },
            dataLabels: {
                enabled: false,              
            },
            stroke: {
                curve: 'smooth',
                width: 2,
            },                                  
            title: {
                text: 'geswatio.com',
                align: 'left',
                margin: 15,
                style: {
                    fontSize: '14px',
                    fontWeight: 'normal',                    
                    color: '#33ab9e'
                },
            },
            colors: ["#2196f3", "#ff5252", '#46AF78', "#663F59", "#6A6E94", "#4E88B4", "#00A7C6", "#18D8D8", '#A9D794',
                 '#A93F55', '#8C5E58', '#2176FF', '#33A1FD', '#7A918D', '#BAFF29','#F3B415'
              ],
            grid: {
                borderColor: '#e7e7e7',
                row: {
                    colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                    opacity: 0.5
                },
                padding: {
                    top: 20
                }
            },
            markers: {
                size: 1,
                strokeWidth: 0,
            },
            xaxis: {
                type: "datetime",
                labels: {
                    format: 'dd/MM/yyyy HH:mm',
                    datetimeUTC: false
                },               
            },
            yaxis: {
                title: {
                    text: ''
                },           
            },
            legend: {
                position: 'top',
                horizontalAlign: 'right',
                floating: true,
                offsetY: -27,
                offsetX: 0,
                show: true,
                showForSingleSeries: true,
                showForNullSeries: true,
                showForZeroSeries: true,
            }
        };

        series = [];
     
        getPrevNextPeriod(direction) {          
            const max = moment(this.$data.toDate, 'DD/MM/YYYY HH:mm:ss');
            const min = moment(this.$data.fromDate, 'DD/MM/YYYY HH:mm:ss');            
            const minutes = max.diff(min, 'minutes');
            if (direction === 'N') {
                this.$refs.filtergraph.dateFrom = max.toDate();
                this.$refs.filtergraph.dateTo = max.add(minutes, 'minutes').toDate();
            }
            else {
                this.$refs.filtergraph.dateTo = min.toDate();
                this.$refs.filtergraph.dateFrom = min.subtract(minutes, 'minutes').toDate();
            }
            this.$refs.filtergraph.onAccept();            
        }   
        redrawChart(size) {          
            this.$refs.realtimeChart.updateOptions({
                stroke: {
                    curve: 'smooth',
                    width: size,
                }, 
            })
        }
        redrawChartMarker(size) {
            this.$refs.realtimeChart.updateOptions({
                markers: {
                    size: size
                },
            })
        }
        async loadData() {
            if (this.$route.params.idI && this.$route.params.idE && this.$route.params.idV) {
                var instalacion = await new InstalationsService().get(this.$route.params.idI);
                var variable = await new VariableService().get(this.$route.params.idV);

                var elemento = await new ElementService().get(this.$route.params.idE);
                this.$data.nombreInstalacion = instalacion.instalation.fldTNombre;
                this.$data.nombreVariable = variable.variable.fldTNombre;
                this.$data.nombreElemento = elemento.element.fldTNombre;
            }
        }

        onAccept() {
            this.dialog = false;
            this.showFilter = false;
            this.showChart = true;
        }
        onBack() {
            this.showFilter = true;
            this.showChart = false;
        }
        formatDateYYYYMMDD(dateString, culture) {
                        
            const [date, hour, am_pm] = dateString.split(' ');
            
            if (culture.split('-')[0] === 'en') {
                const [month, day, year] = date.split('/');
                return `${year}-${month}-${day} ${hour} ${am_pm}`;
            }
            else {
                const [day, month, year] = date.split('/');
                return `${year}-${month}-${day} ${hour} ${am_pm}`;
            }
           
            
        }

        async onSelectedValues(valuesList) {            

            //Set size line and marker size         
            this.$data.chartOptionsApexCharts.stroke.width = this.$data.sizeLine;
            this.$data.chartOptionsApexCharts.markers.size = this.$data.sizeMarker;

            this.chartData = [];

            // Fechas en el titulo del grafico
            if (valuesList.length > 0) {                
                let dateFrom = moment.utc(valuesList[0].from).local();
                this.$data.fromDate = dateFrom.format('DD/MM/YYYY HH:mm:ss');
                //valuesList[0].from = dateFrom.format('YYYY/MM/DD HH:mm:ss');

                let dateTo = moment.utc(valuesList[0].to).local();
                this.$data.toDate = dateTo.format('DD/MM/YYYY HH:mm:ss');
                //valuesList[0].to = dateTo.format('YYYY/MM/DD HH:mm:ss');
            }
            this.$data.series = []; 
            for (var j = 0; j < valuesList.length; j++) {

                let dateFrom = moment.utc(valuesList[j].from).local();              
                valuesList[j].from = dateFrom.format('YYYY/MM/DD HH:mm:ss');

                let dateTo = moment.utc(valuesList[j].to).local();              
                valuesList[j].to = dateTo.format('YYYY/MM/DD HH:mm:ss');

                var resL = await new ChartService().GetChartHistoryData(valuesList[j]);
                if (resL.success == false) {
                    this.showError(resL.message);
                    return;
                }

                var dataL = resL.data;
                const culture = resL.culture;
                if (dataL.length == 0) {
                    this.showError("La variable seleccionada no tiene registros en el rango de fechas establecido: " +
                        this.$data.fromDate + '-' + this.$data.toDate);
                }
                else {
                    var seriesTitleL = "Variable";                    
                    seriesTitleL = dataL[0].codigo + ' ' + dataL[0].instalacion + '-' + dataL[0].tipoElemento + '-' + dataL[0].variable;
                    dataL = dataL.map(x => ({ 'ejeX': x.valorFechaYYYYMMDD, 'ejeY': x.valorTexto.replace(/,/g, '.') }));                    
                   
                    const dataserie_map = dataL.map(v => {                                               
                        return [new Date(v.ejeX), v.ejeY];                        
                    })                    
                    this.$data.series.push({
                        name: seriesTitleL, //Nombre serie
                        data: dataserie_map
                    })

                }             

            }
              
            if (valuesList.length == 1) {
                this.$data.nombreInstalacion = valuesList[0].nombreInstalacion;
                this.$data.nombreVariable = valuesList[0].nombreVariable;
                this.$data.nombreElemento = valuesList[0].nombreElemento;                
            }
            else {
                this.$data.nombreInstalacion = "Multiples variables";
                this.$data.nombreVariable = "";
                this.$data.nombreElemento = "";
                
            }

            this.showChart = true;
        }

        async createPDF() {
            var element = await document.querySelector('.grafico');

            var pdfOptions = {
                orientation: "landscape", // One of "portrait" or "landscape" (or shortcuts "p" (Default), "l")
                unit: "mm",               // Measurement unit to be used when coordinates are specified. One of "pt" (points), "mm" (Default), "cm", "in"
                format: "a4"              // One of 'a3', 'a4' (Default),'a5' ,'letter' ,'legal'
            };
            const today = new Date();
            // Creamos el pdf
            var doc = new jsPDF(pdfOptions);
            doc.setFillColor(245);
            // Seteamos el Titulo
            doc.text(this.$data.nombreInstalacion +" " +  this.$data.nombreElemento+" - " + this.$data.fromDate + " al " + this.$data.toDate, 10, 15);

            var pageWidth = doc.internal.pageSize.width - 20;
            var pageHeight = doc.internal.pageSize.height - 20;

            html2canvas(element, {
                allowTaint: true,
                useCORS: true,
                background: "#FFFFFF"
            }).then(canvas => {
                var imgWidth = canvas.width;
                var imgHeight = canvas.height;
                // Height alternativo
                var height = (pageWidth * imgHeight) / imgWidth;
                var imgData = canvas.toDataURL('image/png');
                doc.addImage(imgData, 'PNG', 10, 30,pageWidth,100);
                
                doc.save('Gráfico.pdf');
            });

            
        }

    }
</script>
<style lang="scss" scoped>
    .apexcharts-zoomin-icon .apexcharts-zoomout-icon {
        transform: scale(0.9) !important;
    }

</style>